export const authModalIds = {
    SWITCH_TO_CREATOR_PLATFORM_MODAL: 'SWITCH_TO_CREATOR_PLATFORM_MODAL',
};
